import z from "zod";

export const CHAT_QUICK_REPLIES_FENCE = "kassaro-options";

const QUICK_REPLIES_PATTERN = new RegExp(
  "```" + CHAT_QUICK_REPLIES_FENCE + "[ \\t]*\\n([\\s\\S]*?)```\\s*$",
);

const JSON_STRING = String.raw`"(?:[^"\\\u0000-\u001f]|\\(?:["\\/bfnrt]|u[0-9a-fA-F]{4}))*"`;

const JSON_STRING_ARRAY_PATTERN = new RegExp(
  String.raw`^\s*\[\s*(?:${JSON_STRING}\s*(?:,\s*${JSON_STRING}\s*)*)?\]\s*$`,
);

const QuickRepliesScheme = z.array(z.string().min(1)).max(8);

const parseQuickReplies = (block: string): string[] => {
  if (!JSON_STRING_ARRAY_PATTERN.test(block)) {
    return [];
  }
  const parsed = QuickRepliesScheme.safeParse(JSON.parse(block));
  return parsed.success ? parsed.data : [];
};

export const splitChatQuickReplies = (
  content: string,
): { text: string; quickReplies: string[] } => {
  const match = QUICK_REPLIES_PATTERN.exec(content);
  if (match === null) {
    return { text: content, quickReplies: [] };
  }
  return {
    text: content.slice(0, match.index).trimEnd(),
    quickReplies: parseQuickReplies(match[1] ?? ""),
  };
};
